<template>
  <div
    id="home"
    class="home"
  >
    <home-sidebar
      :active="sidebar"
      :expanded="sidebarExpanded"
      :locked="sidebarLocked"
      @reset="setSidebar"
      @expand="expandSidebar"
      @lock="lockSidebar"
    />
    <div
      class="overlay"
      :class="{ 'shown': sidebar }"
    />
    <main :class="{ 'expanded': !sidebarExpanded }">
      <div>
        <home-header
          :sidebar-expanded="sidebarExpanded"
          @toggle-sidebar="setSidebar(!sidebar)"
        />
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import HomeHeader from '@/partials/HomeHeader'
import HomeSidebar from '@/partials/HomeSidebar'

export default {
  components: {
    HomeHeader,
    HomeSidebar
  },

  data: () => ({
    sidebar: false,
    sidebarExpanded: false,
    sidebarLocked: false
  }),

  created() {
    this.$root.$on('scrollToTop', this.scrollToTop)
  },

  methods: {
    setSidebar(value) {
      this.sidebar = value
    },
    expandSidebar(value) {
      this.sidebarExpanded = value
    },
    lockSidebar() {
      this.sidebarLocked = !this.sidebarLocked
    },
    scrollToTop() {
      VueScrollTo.scrollTo('#dashboard', 500, {
        container: '#dashboard'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: var(--bg-light-blue);
  bottom: 0;
  left: 0;
  overflow-y: auto;
  padding-top: 50px;
  position: fixed;
  right: 0;
  top: 0;
  overflow: hidden;
}

.overlay {
  background: #000;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: 0.3s;
  visibility: hidden;
  z-index: 102;

  &.shown {
    opacity: 0.9;
    visibility: visible;
  }
}

main {
  background-color: #fff;
  border-bottom-left-radius: 32px;
  border-bottom-right-radius: 32px;
  margin: 25px 12px 12px 12px;
  height: 95%;
  padding: 20px 20px 20px 20px;
  overflow: auto;
  transition: 0.3s;

  @media screen and (min-width: 992px) {
    margin-left: 230px;

    &.expanded {
      margin-left: 80px;
    }
  }
}
</style>
